module.exports = __webpack_public_path__ + "images/resource-300x300.37ebbee32ffed3373d05.png";